import { useBreakpoint } from '@/app/hooks/useBreakpoint'
import { getItemsPerPage } from './getItemsPerPage'
import type { Account } from '../ui/AccountCard'

// Считает, на какой странице пагинации окажется первый уже выбранный аккаунт,
// чтобы открыть грид сразу на нужной странице, а не заставлять искать вручную.
export const useInitialAccountPage = (
  accounts: Account[],
  selectedAccounts: string[]
): number => {
  const { isXs, isSm, isMd, isLg, isXl } = useBreakpoint()
  const itemsPerPage = getItemsPerPage({ isXs, isSm, isMd, isLg, isXl })

  if (selectedAccounts.length === 0) return 1

  const selectedIndex = accounts.findIndex((account) =>
    selectedAccounts.includes(account.id)
  )
  if (selectedIndex === -1) return 1

  return Math.floor(selectedIndex / itemsPerPage) + 1
}
